import React, { useEffect, useState } from 'react';

/**
 * Ein Textfeld, das erst beim Verlassen (oder mit Enter) schreibt.
 *
 * Der Hook des Moduls laedt nach jedem Schreiben das ganze Buendel neu. Ein
 * Feld, das bei jedem Zeichen schreibt, loest damit pro Tastendruck einen
 * Datenbank-Umlauf aus — und der Anwender tippt gegen den zurueckkommenden
 * alten Stand an. Deshalb haelt das Feld einen Entwurf und gibt ihn erst
 * beim Verlassen ab, genau wie die Texte im Kapitel-Reiter.
 */
type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'onBlur'> & {
    wert: string;
    aufSpeichern: (wert: string) => void;
};

export const EntwurfInput: React.FC<Props> = ({ wert, aufSpeichern, ...rest }) => {
    const [entwurf, setEntwurf] = useState(wert);
    useEffect(() => { setEntwurf(wert); }, [wert]);

    const abgeben = () => { if (entwurf !== wert) aufSpeichern(entwurf); };

    return (
        <input
            {...rest}
            value={entwurf}
            onChange={e => setEntwurf(e.target.value)}
            onBlur={abgeben}
            onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }}
        />
    );
};
